export enum PageKind {
  BROWSE_PAGE = 'BrowseCoursesPage',
  COURSE_INFO_PAGE = 'CourseInfoPage',
  COURSE_REG_DETAILS_PAGE = 'CourseDetailPage',
  WEBINAR_PAGE = 'LessonPage',
  CANCELLATION_FAILURE_PAGE = 'CancellationFailurePage',
  ACCOUNT_INFO_PAGE = 'AccountInfoPage',
  STUDENT_PROFILE_PAGE = 'StudentProfilePage',
  MEMBERSHIP_MANAGEMENT_PAGE = 'MembershipManagementPage',
  SHARED_LEARNING_PAGE = 'SharedLearning',
  PAUSE_PAGE = 'PausePage',
  CANCELLATION_CONFIRMATION_PAGE = 'CancellationConfirmationPage',
  ADD_NEXT_MODULE_PAGE = 'AddNextModulePage',
  ASSESSMENT_FAIL_PAGE = 'AssessmentFailPage',
  ASSESSMENT_PASS_PAGE = 'AssessmentPassPage',
  ASSESSMENT_PAGE = 'AssessmentPage',
  ASSESSMENT_WAIT_PAGE = 'AssessmentWaitPage',
  CERTIFICATE_PAGE = 'CertificatePage',
  LESSONS_PAGE = 'LessonsPage',
  RESOURCES_PAGE = 'ResourcesPage',
  ASSIGNMENTS_PAGE = 'AssignmentsPage',
  REQUEST_HCD_PAGE = 'RequestHCDPage',
  PAST_DUE_SUBSCRIPTION_PAGE = 'PastDueSubscriptionPage',
  REACTIVATION_PAGE = 'ReactivationPage',
  RESUME_SUBSCRIPTION_PAGE = 'ResumeSubscriptionPage',
  COURSE_SCHEDULE_PAGE = 'CourseSchedulePage',
  COURSE_SCHEDULE_THANK_YOU_PAGE = 'CourseScheduleThankYouPage',
  THANK_YOU_PAGE = 'ThankYouPage',
  TIME_TABLE_PAGE = 'TimeTablePage',
  HELP_CENTER_PAGE = 'HelpCenterPage',
  CHANGE_LOG_PAGE = 'ChangeLogPage'
}
